export default "/public/img/person.9873fafd.png";